<p>
  Ако сте забравили своята парола и не може да влезете в профила си, не се притеснявайте – процесът по възстановяване
  е бърз и сигурен.
</p>
<h6 class="mt-3">Стъпки за възстановяване на парола</h6>
<p>
  Навигирайте до страницата за <strong>„Вход“</strong> и изберете опцията <strong>„Забравена парола“</strong>, или
  отворете директно страницата за
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.passwordRecovery]">
    възстановяване на парола.
  </a>
</p>
<p class="mb-1">
  Следвайте следните стъпки:
</p>
<ol>
  <li>Въведете имейл адреса, с който сте регистрирани в платформата.</li>
  <li>Натиснете бутона <strong>„Изпрати заявка“</strong>.</li>
  <li>Проверете своя имейл – ще получите съобщение с линк за възстановяване.</li>
  <li>Кликнете върху линка и въведете нова парола по ваш избор.</li>
</ol>
<h6 class="mt-3">Какво да очаквате?</h6>
<p>
  След успешното въвеждане на нова парола, ще може отново да влизате в профила си с нея. Старата парола ще бъде
  деактивирана автоматично.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте сигурна парола, която съдържа комбинация от
  <strong>букви, цифри и специални символи</strong>.
  Избягвайте лесно предвидими комбинации като <em>123456</em>, <em>password</em> или <em>име+година</em>.
</div>
